import React from 'react';

import ClaimStepContainer from '../common/ClaimStepContainer';

function PartialDamageStepContainer(props) {
  return <ClaimStepContainer {...props} subHeading="PARTIAL_DAMAGE_CLAIM_FLOW_HEADING" confirmExit />;
}

export default React.memo(PartialDamageStepContainer);
